import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillAlt, faBuilding } from '@fortawesome/pro-light-svg-icons';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import { classes } from './styles/tree';
import { Collapse } from 'reactstrap';

class CustomerTree extends React.Component {

  render() {
    const { customers, locations, selected, onSelectCustomer, onSelectLocation, disabled, open, onToggleOpen } = this.props;
    return (
      <React.Fragment>
        {
          customers.map(
            (customer, customerIndex) => {
              const customerLocations = locations
                .filter(({ parentUuid }) => parentUuid === customer.uuid);
              return (
                <React.Fragment key={customerIndex}>
                  <div className={`${classes.customer} ${selected === customer.uuid ? classes.selected : ''}`}>
                    <div className={classes.openToggleContainer} onClick={disabled ? null : (event => onToggleOpen(customer.uuid, event))}>
                      <FontAwesomeIcon icon={faCaretRight} rotation={open.indexOf(customer.uuid) > -1 ? 90 : null} className={classes.openToggle} />
                    </div>
                    <FontAwesomeIcon icon={faMoneyBillAlt} onClick={disabled ? null : (event => onSelectCustomer(customer.uuid, customer, event))} />
                    <div className={classes.label} onClick={disabled ? null : (event => onSelectCustomer(customer.uuid, customer, event))}>
                      {customer.name}
                    </div>
                  </div>
                  <Collapse isOpen={open.indexOf(customer.uuid) > -1}>
                    {
                      customerLocations
                        .map(
                          (location, locationIndex) => (
                            <div className={`${classes.location} ${selected === location.uuid ? classes.selected : ''}`} onClick={disabled ? null : (event => onSelectLocation(location.uuid, location, event))} key={locationIndex}>
                              <FontAwesomeIcon icon={faBuilding} />
                              <div className={classes.label}>
                                {location.name}
                              </div>
                            </div>
                          )
                        )
                    }
                  </Collapse>
                </React.Fragment>
              )
            }
          )
        }
      </React.Fragment>
    )

  }

}

CustomerTree.propTypes = {
  onToggleOpen: PropTypes.func.isRequired,
  open: PropTypes.arrayOf(
    PropTypes.string.isRequired
  ),
  customers: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      parentUuid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  selected: PropTypes.string,
  onSelectCustomer: PropTypes.func.isRequired,
  onSelectLocation: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};


export default CustomerTree;


// WEBPACK FOOTER //
// ./src/views/customer/tree.js